<div id="layout-wrapper">
  <!--topbar-->
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/" class="logo">
            <span
              class="logo-box bs-text-xl text-mid font-color-wh text-center w-100"
              *ngIf="!isCondensed"
            >
              <!-- TODO 로고 바꾸기-->
              <!-- <img src="assets/imgs/small-logo.png" alt="" *ngIf="!isCondensed" />
              <img src="assets/imgs/logo-startapp.png" alt="" *ngIf="isCondensed" /> -->
              HangCok Talk<br />
              <span class="text-400">Admin</span>
            </span>

            <p
              class="logo-box cus-logo-box bs-text-s text-mid font-color-wh text-center w-100 p-0"
              *ngIf="isCondensed"
            >
              HangCok<br />Talk
            </p>
          </a>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          id="vertical-menu-btn"
          (click)="toggleMobileMenu($event)"
          (settingsButtonClicked)="onSettingsButtonClicked()"
          (mobileMenuButtonClicked)="onToggleMobileMenu()"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <!-- 알람 내역 -->
        <ng-container *ngIf="notifications$ | async as notifications">
          <div class="dropdown d-inline-block" ngbDropdown>
            <button
              type="button"
              class="btn header-item noti-icon"
              id="page-header-notifications-dropdown"
              ngbDropdownToggle
            >
              <i class="bx bx-bell bx-tada"></i>
              <span class="badge badge-danger badge-pill">{{
                unReadLength
              }}</span>
            </button>
            <div
              class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
              aria-labelledby="page-header-notifications-dropdown"
              ngbDropdownMenu
            >
              <div class="p-3">
                <div class="row align-items-center">
                  <div class="col">
                    <h6 class="m-0">알람</h6>
                  </div>
                  <div class="col-auto">
                    <a
                      href="javascript: void(0);"
                      class="small"
                      (click)="delete()"
                      >전체 삭제</a
                    >
                  </div>
                </div>
              </div>

              <perfect-scrollbar
                style="position: relative; height: 230px"
                [config]="configData"
              >
                <!-- 알람이 없을 때 -->
                <p
                  class="text-secondary text-center pt-3 pb-3"
                  *ngIf="notifications?.length == 0 || !notifications"
                >
                  받은 알림이 없어요.
                </p>

                <ng-container *ngFor="let item of notifications">
                  <a class="text-reset notification-item" (click)="alarm(item)">
                    <div class="media">
                      <div class="media-body">
                        <h6 class="mt-0 mb-1">
                          {{ item.title }}
                          <!-- 새로운 알림 -->
                          <span
                            class="new-badge bs-text-s"
                            *ngIf="!item.readSwitch"
                            >new</span
                          >
                        </h6>
                        <div class="font-size-12 text-muted">
                          <p class="mb-0">
                            {{ displayedAt(item.dateCreated) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </ng-container>
              </perfect-scrollbar>
            </div>
          </div>
        </ng-container>
        <!--///알람 내역 끝-->

        <button
          class="btn header-item font-size-14 d-flex align-items-center"
          (click)="logout()"
        >
          <i class="bx bx-log-out mr-1"></i>
          로그아웃
        </button>
      </div>
    </div>
  </header>

  <ng-template #contentTemplate>
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->

      <!--메인메뉴-->
      <ul class="metismenu list-unstyled" *ngIf="menu">
        <li *ngFor="let list of menu; let menuIndex = index">
          <!--서브메뉴 없을때-->
          <a
            *ngIf="!list.subItems || list.subItems?.length == 0"
            routerLink="{{ list.link }}"
            routerLinkActive="active"
            #aTag
            (click)="close(aTag)"
          >
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span></a
          >
          <!--서브메뉴 있을때-->
          <a
            *ngIf="list.subItems && list.subItems?.length > 0"
            class="has-arrow"
            href="javascript: void(0);"
            (click)="open(list, menu, menuIndex)"
            [ngClass]="{ 'up-arrow': list.openSwitch }"
          >
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span></a
          >
          <!--서브메뉴 리스트-->
          <ul
            class="sub-menu"
            aria-expanded="true"
            [ngClass]="{ 'side-close': !list.openSwitch }"
          >
            <li *ngFor="let item of list.subItems; let i = index">
              <a
                class="side-nav-link-ref, atag{{ menuIndex }}{{ i }}"
                [routerLink]="item.link"
                routerLinkActive="active"
              >
                <span>{{ item.label }}</span></a
              >
            </li>
          </ul>
        </li>

        <!-- end Layout menu -->

        <!-- </ng-container> -->
      </ul>
    </div>
  </ng-template>
  <!-- Sidebar -->

  <div class="vertical-menu">
    <perfect-scrollbar [config]="configData">
      <div *ngIf="!isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
      <div *ngIf="isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
    </perfect-scrollbar>
  </div>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
